module.exports = {"TXTWCL_Clear_Bets":{"id":"TXTWCL_Clear_Bets","defaultMessage":"ベットをクリア"}}